import { axiosInstance } from '@/http-common'

/**
 * Load all geofencing by companyId
 */
export async function getAllGeoFencings(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/data/geofencing')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

/**
 * Load all geofencing events
 */
export async function getAllGeoFencingEvents(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/data/geofencing_events')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}